<script setup>
import { computed } from 'vue';

const props = defineProps({
  reactions: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['react']);

const reactionList = computed(() => {
  return Object.entries(props.reactions)
    .filter(([, count]) => count > 0)
    .map(([emoji, count]) => ({ emoji, count }));
});

function handleClick(emoji) {
  emit('react', emoji);
}
</script>

<template>
  <!-- eslint-disable-next-line vue/no-root-v-if -->
  <div v-if="reactionList.length > 0" class="flex flex-wrap gap-1 mt-1">
    <button
      v-for="{ emoji, count } in reactionList"
      :key="emoji"
      class="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-xs bg-n-alpha-2 hover:bg-n-alpha-3 border border-n-weak cursor-pointer transition-colors"
      @click="handleClick(emoji)"
    >
      <span>{{ emoji }}</span>
      <span v-if="count > 1" class="text-n-slate-11">{{ count }}</span>
    </button>
  </div>
</template>
